import React from "react";
import { Link } from "react-router-dom";
import PLayout from "./PLayout";
import { useApp } from "@/context/AppContext";
import { useAppUi } from "@/i18n/appUi";
import { getUi, getTiles } from "@/portal/portal";

export default function Part1() {
  const { lang } = useApp();
  const t = useAppUi(lang);
  const tp = getUi(lang);
  return (
    <PLayout>
      <div className="rbl-eyebrow">{t("p1Kicker")}</div>
      <h1 className="rbl-h1" style={{ fontSize: 40 }} data-testid="part1-title">{t("p1Title")}</h1>
      <p className="rbl-intro">{t("p1Intro")}</p>
      <div className="rbl-grid" style={{ marginTop: 24 }} data-testid="part1-sessions">
        {getTiles(lang).map((s) => (
          <Link to={`/app/part1/${s.number}`} className="rbl-card" key={s.number} data-testid={`part1-session-${s.number}`}>
            <span className="rbl-card-num">{String(s.number).padStart(2, "0")}</span>
            <span className="rbl-card-emoji">{s.icon}</span>
            <span className="rbl-card-title">{s.title}</span>
            <span className="rbl-card-meta">{s.subtitle}</span>
            <span className="rbl-card-cta">{tp("openSession")}</span>
          </Link>
        ))}
      </div>
    </PLayout>
  );
}
